import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import ProfilePage from "./profile";
import { getUserByEmail } from "../services/sheetsService";

const UserDetails = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userEmail = localStorage.getItem("userEmail");

  useEffect(() => {
    if (!userEmail) {
      setLoading(false);
      return;
    }

    const fetchUserData = async () => {
      try {
        const userData = await getUserByEmail(userEmail);
        if (userData) {
          // Wrap in the shape ProfilePage expects: { data: { name, email, ... } }
          setUser({ data: userData });
        } else {
          setError("User profile not found.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [userEmail]);

  return (
    <Box sx={{ display: "flex" }}>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : user ? (
          <ProfilePage user={user} />
        ) : (
          <Typography>No profile data available.</Typography>
        )}
      </Box>
    </Box>
  );
};

export default UserDetails;
